import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesSection from './components/ServicesSection';
import MidPageCTA from './components/MidPageCTA';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <TrustBar />
      <ServicesSection />
      <MidPageCTA />
      <AIAnswerBlock />
      <ProcessSection />
      <WhyChooseUs />
      <ServiceAreas />
      <TestimonialsSection />
      <FAQSection />
      <FinalCTA />
    </main>
  );
}
